import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-feedback-submit',
  templateUrl: './client-feedback-submit.component.html',
  styleUrls: ['./client-feedback-submit.component.scss']
})
export class ClientFeedbackSubmitComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ClientFeedbackSubmitComponent>,
    private router: Router,) { }

  ngOnInit(): void { 
  }


  closePopup() {
      
      this.dialogRef.close(true)
      this.router.navigate(["/landing-page"])
  }
}
